//==============================================================================
// Customer Match
//
// Uses submitted data to match to a customer record.
//==============================================================================
import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { QueryResultSettingsProxy } from '@msdyn365-commerce-modules/retail-actions';

import { customerMatchAsync } from '../../../actions/DataActionExtension.g';
import { ICustomerMatchCriteria, ICustomResponse_1OfCustomerMatchResult } from '../../../actions/DataServiceEntities.g';

//==============================================================================
// FUNCTIONS
//==============================================================================
//==========================================================
// CustomerMatch Input Action
//==========================================================
export class CustomerMatchInput implements IActionInput {
    public customerMatchCriteria: ICustomerMatchCriteria;

    //------------------------------------------------------
    // Constructor
    //------------------------------------------------------
    constructor(customerMatchCriteria: ICustomerMatchCriteria) {
        this.customerMatchCriteria = customerMatchCriteria;
    }

    //------------------------------------------------------
    // Caching
    //------------------------------------------------------
    public getCacheKey = () => 'CustomerMatch';
    public getCacheObjectType = () => 'CustomerMatch';
    public dataCacheType = (): CacheType => 'none';
}

//==========================================================
//==========================================================
async function customerMatchAction(input: CustomerMatchInput, ctx: IActionContext): Promise<ICustomResponse_1OfCustomerMatchResult> {
    return customerMatchAsync(
        {
            callerContext: ctx,
            queryResultSettings: QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(ctx)
        },
        input.customerMatchCriteria
    ).then(result => {
        return result;
    }).catch(error => {
        ctx.telemetry.exception(error.message);
        ctx.telemetry.debug('Unable to match customer');
        throw new Error('Unable to match customer');
    });
}

//==============================================================================
//==============================================================================
export const customerMatchActionDataAction = createObservableDataAction<ICustomResponse_1OfCustomerMatchResult>({
    id: 'customer-match',    // This can be anything EXCEPT the data action path ('actions/customer-match')
    action: <IAction<ICustomResponse_1OfCustomerMatchResult>>customerMatchAction
});

export default customerMatchActionDataAction;
